import { useMemo } from "react";
import { capitalize, FCX, getFormattedThousand } from "@datassential/platform-ui-lib";
import BarChart, { BarChartItem } from "@components/BarChart/BarChart";
import CategoryProfileCard from "@pages/CategoryProfile/components/CategoryProfileCard/CategoryProfileCard";
import CategoryProfileSubtitle from "@pages/CategoryProfile/components/CategoryProfileSubtitle/CategoryProfileSubtitle";
import { TrendingKeyword } from "@apiHooks/useCategoryProfileTrendingKeywords";
import "./TrendingNowChart.styles.scss";

interface TrendingNowChartProps {
    keywords: TrendingKeyword[];
    categoryName: string;
}

const formatValue = (value: number): string =>
    `${value > 0 ? "+" : ""}${getFormattedThousand(Math.round(value))}%`;

const TrendingNowChart: FCX<TrendingNowChartProps> = ({ keywords, categoryName }) => {
    const chartData: BarChartItem[] = useMemo(
        () => keywords.map(({ name, value }) => ({ id: name, name, value })),
        [keywords]
    );

    return (
        <div className="TrendingNowChart" data-testid="blockCategoryProfileTrendingNowChart">
            <CategoryProfileCard className="TrendingNowChart__card">
                <div>
                    <CategoryProfileSubtitle>{capitalize(categoryName)}</CategoryProfileSubtitle>
                    <span className="TrendingNowChart__subtitle">
                        past 12-month growth in social media engagement
                    </span>
                </div>

                <div className="TrendingNowChart__chart">
                    <BarChart
                        className="TrendingNowChartBarChart"
                        data={chartData}
                        formatValue={formatValue}
                    />
                </div>
            </CategoryProfileCard>
        </div>
    );
};

export default TrendingNowChart;
